export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PASSWORD_PATTERN = /^.{4,}$/i;
export const NAME_PATTERN = /[a-zA-Z]/;
export const COUPON_PATTERN = /(^\S{2}-\S{3}-\S{2}$)|(^\S{4}-\S{4}$)/;
